import { IAmendmentResponse } from '../../../../../../model/sge/amendment/response/amendment-response';
import { ICommitmentResponse } from '../../../../../../model/sge/commitment/response/commitment-response';
import { ILiquidationResponse } from '../../../../../../model/sge/liquidation/response/liquidation-response';
import { IPaymentResponse } from '../../../../../../model/sge/payment/response/payment-response';
import { ITransferResponse } from '../../../../../../model/sge/transfer/response/transfer-response';
import { IAccountReportResponse } from '../../../../../../model/sge/account-report/response/account-report-response';
import { IAttachmentResponse } from '../../../../../../model/sge/attachment/response/attachment-response';

export type PublicAmendmentDetailState = {
    amendmentId: string;
    amendment?: IAmendmentResponse;
    parlamentarName?: string;
    politicalPartyAbbreviation?: string;
    tabIndex: number;
    commitments: ICommitmentResponse[];
    selectedCommitment?: ICommitmentResponse;
    liquidations: ILiquidationResponse[];
    payments: IPaymentResponse[];
    transfers: ITransferResponse[];
    accountReports: IAccountReportResponse[];
    attachments: IAttachmentResponse[];
};

export enum ACTION_TYPES {
    setAmendment = 'setAmendment',
    setTabIndex = 'setTabIndex',
    setCommitments = 'setCommitments',
    setSelectedCommitment = 'setSelectedCommitment',
    setLiquidations = 'setLiquidations',
    setPayments = 'setPayments',
    setTransfers = 'setTransfers',
    setAccountReports = 'setAccountReports',
    setAttachments = 'setAttachments',
}

export const PublicAmendmentDetailReducer = (state: PublicAmendmentDetailState, action: any): PublicAmendmentDetailState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setAmendment: return { ...state, amendment: payload };
        case ACTION_TYPES.setTabIndex: return { ...state, tabIndex: payload };
        case ACTION_TYPES.setCommitments: return { ...state, commitments: payload };
        case ACTION_TYPES.setSelectedCommitment: return { ...state, selectedCommitment: payload, liquidations: [], payments: [] };
        case ACTION_TYPES.setLiquidations: return { ...state, liquidations: payload };
        case ACTION_TYPES.setPayments: return { ...state, payments: payload };
        case ACTION_TYPES.setTransfers: return { ...state, transfers: payload };
        case ACTION_TYPES.setAccountReports: return { ...state, accountReports: payload };
        case ACTION_TYPES.setAttachments: return { ...state, attachments: payload };
        default: throw new Error(`Unhandled action type: ${type}`);
    }
};
